import { observer } from "mobx-react-lite"

import type { VenammSellStore } from "@/domains/venamm"
import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { MultilineMessageBox } from "@/domains/common/components/multi-line-message-box"
import { BodySM } from "@/domains/design/components/body-sm"

interface VenammResetFailedProps {
  store: VenammSellStore
}

export const VenammResetFailed = observer(({ store }: VenammResetFailedProps) => {
  return (
    <MultilineMessageBox variant="error" icon={<MessageBoxIcon size={"md"} variant="error" />}>
      <BodySM className="mt-[3px] text-error-text">Reset failed. Please try again:</BodySM>
      <BodySM className="my-5 rounded-md border border-error-background/20 bg-error-background/[0.15]  px-4 py-2 text-error-text">
        {store.resetError ?? "Unknown error"}
      </BodySM>
    </MultilineMessageBox>
  )
})

